import { render } from "./RegistrationPanel.vue?vue&type=template&id=1549e293&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=1549e293&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1549e293"

export default script